<template>
  <div>
    <div class="rsvp-content--center" v-if="isLoading">
      <div class="d-flex align-center">
        <v-progress-circular
          indeterminate
          color="primary"
          class="mr-2"
        ></v-progress-circular>
        <span class="subtitle-1"> Please wait... </span>
      </div>
    </div>
    <div class="rsvp-content--center" v-else-if="successMessasge">
      <div class="text-center">
        <p class="mb-0">
          {{ successMessasge }}
        </p>
      </div>
    </div>
    <div class="rsvp-content--center" v-else-if="message">
      <div class="text-center">
        <p class="mb-0">Error while building the form</p>
        <p class="red--text mb-0">
          {{ message }}
        </p>
      </div>
    </div>
    <div class="rsvp-form" v-else>
      <validation-observer ref="observer" v-if="fieldList.length">
        <v-row no-gutters>
          <v-col cols="12" class="px-2" v-html="html"> </v-col>
          <v-col
            cols="12"
            class="px-2"
            :md="isTextArea(fieldId) ? 12 : 6"
            v-for="(fieldId, index) of fieldOrder"
            :key="index"
          >
            <validation-provider
              v-slot="{ errors }"
              :rules="getRules(fieldId)"
              :name="getField(fieldId).field_name"
              :vid="getRef(fieldId)"
            >
              <template v-if="isField(fieldId)">
                <v-checkbox
                  :label="getField(fieldId).field_name"
                  v-model="form[fieldId]"
                  class="mt-7"
                  v-if="getField(fieldId).field_type == 'checkbox'"
                ></v-checkbox>
                <template v-else>
                  <v-label>
                    {{ getField(fieldId).field_name }}
                    <span class="red--text" v-if="getField(fieldId).required"
                      >*</span
                    ></v-label
                  >
                  <v-text-field
                    v-if="isTextField(fieldId)"
                    :error-messages="errors"
                    outlined
                    :autocomplete="getField(fieldId).autofill"
                    v-model="form[fieldId]"
                    :type="getField(fieldId).field_type"
                    dense
                  ></v-text-field>
                  <v-autocomplete
                    v-if="isSelect(getField(fieldId).field_type)"
                    :items="getOptions(getField(fieldId))"
                    v-model="form[fieldId]"
                    :error-messages="errors"
                    :autocomplete="getField(fieldId).autofill"
                    outlined
                    dense
                  ></v-autocomplete>
                  <v-textarea
                    v-if="getField(fieldId).field_type == 'textarea'"
                    v-model="form[fieldId]"
                    :error-messages="errors"
                    :autocomplete="getField(fieldId).autofill"
                    outlined
                    name="input-7-4"
                  ></v-textarea>
                </template>
              </template>
            </validation-provider>
          </v-col>
        </v-row>
        <div class="d-flex mr-2">
          <v-spacer></v-spacer>
          <v-btn width="150px" class="primary" depressed large @click="submit()"
            >Submit</v-btn
          >
        </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>
import firebase from "../config/firebase.js";
const CONFIRM_EMAIL_ID = "WxpHKAO56aVGvLTjwnMS";
const EMAIL_ID = "PDYADfGWwgzbzCZpzx1i";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  props: {
    event: {},
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      message: "",
      isLoading: false,
      fieldList: [],
      html: "",
      form: {
        PDYADfGWwgzbzCZpzx1i: "",
        WxpHKAO56aVGvLTjwnMS: "",
      },
      eventDetails: {},
      myrules: {
        required: (value) => !!value || "Field is required.",
        email: (value) =>
          /.+@.+\..+/.test(value) || "This value should be a valid email",
      },
      successMessasge: "",
      isValid: false,
      fieldOrder: [],
    };
  },
  computed: {
    confirmEmailRule() {
      let confirmEmail = this.form[EMAIL_ID];
      let email = this.form[CONFIRM_EMAIL_ID];
      return () =>
        email === confirmEmail || "Email and confirm email should be same";
    },
    referrer() {
      let url = "";
      if (document.referrer) {
        url = new URL(document.referrer).host;
      } else if (window.parent.location.href) {
        url = window.parent.location.host;
      }
      return url;
    },
    url() {
      let url = location.href;
      let parentUrl = window.parent.location.href;
      if (url == "about:srcdoc" && parentUrl) url = parentUrl;
      return decodeURIComponent(url);
    },
    search() {
      let url = location.search;
      let parentUrl = window.parent.location.search;
      if (location.href == "about:srcdoc" && parentUrl) url = parentUrl;
      return url;
    },
  },
  methods: {
    getRef(fieldId) {
      if (EMAIL_ID == fieldId) return "email";
      return fieldId;
    },
    fetchParams() {
      let doc = {};
      const vm = this;
      let { referrer, url } = this;
      [
        "utm_medium",
        "utm_source",
        "utm_campaign",
        "utm_term",
        "gclid",
        "fbclid",
        "utm_content",
      ].map((key) => {
        doc[key] = findGetParameter(key) || "";
      });
      if (doc["gclid"]) {
        doc["source"] = "Google Ads";
      } else if (doc["fbclid"]) {
        doc["source"] = "Facebook Ads";
      } else if (referrer) {
        doc["source"] = referrer;
      } else {
        if (location.href == "about:srcdoc") {
          doc["source"] = location.host;
        } else {
          doc["source"] = window.parent.location.host || "";
        }
      }
      doc["referrer_url"] = referrer;
      doc["signup_url"] = url;
      function findGetParameter(parameterName) {
        var result = null,
          tmp = [];
        vm.search
          .substr(1)
          .split("&")
          .forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
          });
        return result;
      }
      return doc;
    },
    isConfirmEmail(id) {
      return id == CONFIRM_EMAIL_ID;
    },
    isTextArea(id) {
      let field = this.getField(id);
      return field ? field.field_type == "textarea" : false;
    },
    getRules(id) {
      let field = this.getField(id);
      if (this.isConfirmEmail(id)) return "required|confirmed:email";
      if (field.field_type == "email") return "required|email";
      if (field.required) return "required";
      return "";
    },
    isField(id) {
      if (id == "empty-space" || !this.getField(id)) return false;
      return true;
    },
    isTextField(id) {
      let field = this.getField(id);
      return ["text", "number", "email"].indexOf(field.field_type) != -1;
    },
    isSelect(val) {
      return ["dropdown", "country"].indexOf(val) != -1;
    },
    getOptions({ field_type, options }) {
      let country = require("../config/country.json");
      if (field_type == "country") return country;
      return options;
    },

    getField(id) {
      return this.fieldList.find((item) => item.id == id) || {};
    },
    getFieldName(id) {
      if (id == "empty-space") return "Empty Space";
      let field = this.getField(id);
      return field ? field.field_name : "";
    },
    async fetchFormDetails() {
      const vm = this;
      try {
        if (!vm.event) {
          vm.message = "Event not found";
          return;
        }
        vm.isLoading = true;
        let fs = firebase.firestore();
        let eventRef = fs.collection("events").doc(vm.event);
        vm.eventDetails = (await eventRef.get()).data();
        if (!vm.eventDetails) {
          vm.isLoading = false;
          vm.message = "Event not found";
          return;
        }
        console.log(this.eventDetails.event_name);
        vm.fieldList = vm.getDocs(await fs.collection("fields").get());
        let form = (await fs.collection("rsvpForm").doc("form").get()).data();
        vm.fieldOrder = form.field_order || [];
        vm.fieldOrder.forEach((id) => {
          let field = vm.getField(id);
          if (field) vm.form[id] = field.default_value || "";
        });
        vm.html = form.html;
        vm.isLoading = false;
        vm.initTrackingCode();
      } catch (error) {
        vm.message = error.message;
        vm.isLoading = false;
      }
    },
    getDocs(snap) {
      return snap.docs.map((item) => {
        return { id: item.id, ...item.data() };
      });
    },
    initTrackingCode() {
      let { google_tracking_code, facebook_tracking_code } = this.eventDetails;
      this.loadScript(google_tracking_code);
      this.loadScript(facebook_tracking_code);
    },
    triggerConversation() {
      let { google_conversion_code, facebook_conversion_code } =
        this.eventDetails;

      this.executeConversionCode(google_conversion_code);
      this.executeConversionCode(facebook_conversion_code);
    },
    executeConversionCode(code) {
      if (!code) return;
      try {
        let div = document.createElement("div");
        div.innerHTML = code;
        div.childNodes.forEach((item) => {
          if (item.nodeName == "SCRIPT") {
            eval(item.textContent);
          }
        });
      } catch (error) {
        console.log("Error while executing the conversion code", error.message);
      }
    },
    loadScript(str) {
      let div = document.createElement("div");
      div.innerHTML = str;
      div.childNodes.forEach((item) => {
        if (item.nodeName == "NOSCRIPT") {
          var noscr = document.createElement("noscript");
          noscr.innerHTML = item.innerHTML;
          document.body.append(noscr);
        } else if (item.src) {
          var scr = document.createElement("script");
          scr.src = item.src;
          document.body.append(scr);
        } else if (item.innerText) {
          var script = document.createElement("script");
          script.textContent = item.innerText;
          document.body.append(script);
        }
      });
    },
    async submit() {
      const vm = this;
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let doc = { form: vm.form };
      let fields = vm.fieldOrder.map((id) => {
        if (vm.getField(id)) {
          let { field_type, field_name } = vm.getField(id);
          return { type: field_type, label: field_name, id };
        }
        return { id };
      });
      doc.event = this.event;

      doc.fields = fields;
      doc = { ...doc, ...vm.fetchParams() };
      try {
        vm.isLoading = true;
        let functions = firebase.functions();
        // functions.useFunctionsEmulator("http://localhost:5001");
        let fun = functions.httpsCallable("rsvpFormSubmitActions");
        let { status, message } = (await fun(doc)).data;
        vm.isLoading = false;
        if (!status) {
          alert(message);
          return;
        }
        vm.successMessasge =
          vm.eventDetails.confirmation_message ||
          "Your form has been submitted successfully.";
        vm.triggerConversation();
      } catch (error) {
        console.log(error.message);
        vm.isLoading = false;
      }
    },
  },
  mounted() {
    console.log(this.fetchParams());
    this.fetchFormDetails();
  },
};
</script>

<style lang="scss">
.rsvp-content--center {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.rsvp-form {
  max-width: 800px;
  margin: 0 auto;
}
.v-alert p {
  margin-bottom: 0px !important;
}
.v-input {
  input {
    background: transparent !important;
    font-size: 16px !important;
  }
}
</style>